import React from 'react';
import styles from './welcomeScreen.module.css';

const ChevronRight = () => (
  <svg
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 6l6 6-6 6"
    />
  </svg>
);

const MainLogo = () => (
  <div className='flex items-center gap-2'>
    <img
      src="https://fplogoimages.withfloats.com/actual/69307aedfe3cec81a85953aa.png"
      alt="Dada Gujar Hospital"
      className='h-12 md:h-14 w-auto'
    />
  </div>
);

const ComingSoonScreen = ({
  assessmentType,
  onBack,
}) => {
  const formattedTitle =
    assessmentType
      ?.replace(/_/g, ' ')
      ?.replace(
        /\b\w/g,
        (l) => l.toUpperCase()
      ) || 'Assessment';

  return (
    <div className={styles.welcomeScreen}>
      {/* HEADER */}
      <div className={styles.welcomeHeader}>
        <MainLogo />

        <button
          onClick={onBack}
          className='ava-text-body'
          style={{
            color: 'var(--primary)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Back
        </button>
      </div>

      {/* BODY */}
      <div className={styles.welcomeBody}>
        {/* ICON */}
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius:
              'var(--radius-xl)',
            background:
              'linear-gradient(135deg, var(--primary-100), var(--primary-200))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 24,
            boxShadow:
              'var(--ava-shadow-xs)',
          }}
        >
          <span
            style={{
              fontSize: 42,
            }}
          >
            🚧
          </span>
        </div>

        {/* TITLE */}
        <h1
          className={`ava-heading-md ${styles.welcomeTitle}`}
        >
          Coming Soon
        </h1>

        {/* DESCRIPTION */}
        <p
          className={`ava-text-body ${styles.welcomeDesc}`}
          style={{
            maxWidth: 420,
            textAlign: 'center',
          }}
        >
          The{' '}
          <strong>
            {formattedTitle}
          </strong>{' '}
          is currently under
          development and will be
          available soon with
          personalized screening,
          insights, and care
          guidance.
        </p>

        {/* FEATURES */}
        <div
          className={styles.featureList}
          style={{
            marginTop: 28,
          }}
        >
          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>
              ✨
            </div>

            <div
              className={`ava-text-body ${styles.featureText}`}
            >
              <strong>
                Smart Screening
              </strong>

              <span>
                Personalized
                assessment flow
              </span>
            </div>
          </div>

          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>
              📊
            </div>

            <div
              className={`ava-text-body ${styles.featureText}`}
            >
              <strong>
                Health Insights
              </strong>

              <span>
                Risk analysis &
                recommendations
              </span>
            </div>
          </div>

          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>
              🔒
            </div>

            <div
              className={`ava-text-body ${styles.featureText}`}
            >
              <strong>
                Secure & Private
              </strong>

              <span>
                Confidential health
                data protection
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className={styles.welcomeFooter}>
        <button
          className='btn-primary'
          onClick={onBack}
        >
          Explore Other
          Assessments
          <ChevronRight />
        </button>

        <div
          className={`ava-text-caption ${styles.trustBadge}`}
        >
          More assessments are
          launching soon.
        </div>
      </div>
    </div>
  );
};

export default ComingSoonScreen;